import { gql, useQuery } from '@apollo/client'
import { Template } from '@ui/__generated__/graphql'

const GetTemplatesQL = gql(`
  query GetTemplates($type: SliceType) {
    getTemplates(type: $type) {
      id
      name
      slug
      description
      type
    }
  }
`)

export function GetTemplates({ nodeType }: { nodeType: string }) {
  return useQuery<{ getTemplates: Template[] }>(GetTemplatesQL, {
    variables: {
      type: nodeType,
    },
  })
}
